export default "__VITE_ASSET__4uIYOONt__"